module.exports = "/_next/static/images/a1f164126ca12e99b9a15bf7f813f11d-thumb_video.jpg";